import {
	AUTHENTICATE,
	LOGOUT,
	ADDINTEREST,
	SETINTERESTS,
	SETNAVIGATE,
	LOADINGHOME,
} from "./actionTypes";

const INITIAL_STATE = {
	accessToken: "",
	email: "",
	id: "",
	full_name: "",
	userType: "",
	navigateTo: "",
	lang: "",
};

const AuthReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case LOADINGHOME:
			return {
				...state,
				loadingHome: action.payload.loadingHome,
				loadedBefore: action.payload.loadedBefore,
			};
		case AUTHENTICATE:
			return { ...state, ...action.payload };
		case LOGOUT:
			return {
				...INITIAL_STATE,
			};
		case SETNAVIGATE:
			return { ...state, navigateTo: action.payload };
		case SETINTERESTS:
			return { ...state, ...action.payload };
		case ADDINTEREST:
			return { ...state, ...action.payload };
		default:
			return state;
	}
};

export default AuthReducer;
